<!-- Spacer -->
<div
    class="horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
